import { useIntl } from 'react-intl';
import { AlarmDetailsDto } from '../../services/alarm';
import { useIntlPropertyDescription } from '../useIntlPropertyDescription';

const regex = new RegExp(/{(?<tagName>[^}]+)}/, 'g')

function useIntlAlarmMessage(alarm: AlarmDetailsDto): string | undefined {
    const intl = useIntl();
    const alarmMessageValues = getAlarmMessageValues(alarm);
    const { description, isLoading, isSuccess } = useIntlPropertyDescription(alarm.modelId, alarm.propertyName);

    if ( !alarm.modelId) // old alarms
        return intl.formatMessage({ id: `alarmMessages.${alarm.message}`, defaultMessage: alarm.message }, alarmMessageValues);

    if (!isSuccess )
        return undefined;

    const alarmMessage = description?.replaceAll('${', '{').replace(regex, (find) => getAlarmValue(alarmMessageValues, find))
    return alarmMessage
}

export default useIntlAlarmMessage


function getAlarmMessageValues(alarm: AlarmDetailsDto): any {
    return Object.fromEntries(new Map(alarm.messageValues?.map((item) => [item.key, item.value])));
}

function getAlarmValue(alarmMessageValues, name: string) {
    const nameToFind = name.replace('{', '').replace('}', '')
    return alarmMessageValues[nameToFind]
}